<template>
  <el-container>
    <el-header>
      <headerComponent></headerComponent>
    </el-header>
    <el-main>
      <mainComponent></mainComponent>
    </el-main>
  </el-container>
</template>

<script>
import headerComponent from "@/components/header";
import mainComponent from "@/components/main";

export default {
  name: "indexPage",
  components: {headerComponent,mainComponent},
  data() {
    return {}
  }
}
</script>

<style lang="scss">

</style>